import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const BinIcon = memo((props) => {
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...{
        ...props,
        fill: props.disabled ? "grey" : props.fill || "black",
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3333 1.33333V2.66667H1V1.33333H4.80733C5.40733 1.33333 5.89467 0.600667 5.89467 0H9.438C9.438 0.600667 9.92467 1.33333 10.5253 1.33333H14.3333ZM5.66665 12.6667C5.66665 13.0347 5.36799 13.3333 4.99999 13.3333C4.63199 13.3333 4.33332 13.0347 4.33332 12.6667V6C4.33332 5.632 4.63199 5.33333 4.99999 5.33333C5.36799 5.33333 5.66665 5.632 5.66665 6V12.6667ZM8.33333 12.6667C8.33333 13.0347 8.03467 13.3333 7.66667 13.3333C7.29867 13.3333 7 13.0347 7 12.6667V6C7 5.632 7.29867 5.33333 7.66667 5.33333C8.03467 5.33333 8.33333 5.632 8.33333 6V12.6667ZM10.3333 13.3333C10.7013 13.3333 11 13.0347 11 12.6667V6C11 5.632 10.7013 5.33333 10.3333 5.33333C9.96535 5.33333 9.66668 5.632 9.66668 6V12.6667C9.66668 13.0347 9.96535 13.3333 10.3333 13.3333ZM12.3333 14.6667V4H13.6667V16H1.66668V4H3.00001V14.6667H12.3333Z"
        fillOpacity="0.67"
      />
    </SvgIcon>
  );
});
